// export const BASE_URL = 'http://localhost:7002';
// export const BASE_URL = 'https://dev-report.routeeld.uz';
export const BASE_URL = 'https://report.llorallc.com';
// export const BASE_URL = 'https://report.routeeld.uz';
export const MOCK_TOKEN = 'token';
export const LANG = 'en';

export default {
    LANG,
    MOCK_TOKEN,
    BASE_URL,
};
